/**
 * TEMPORARY diagnostic tool for the region/banner investigation.
 * Not for production use -- delete this file and its <script> tag in
 * theme.liquid once the investigation is closed.
 *
 * Activate with ?consent_debug=1 on any URL (persists for the tab via
 * sessionStorage, so it survives navigation without needing the param on
 * every page -- and clears itself when the tab/incognito window closes).
 * Deactivate with ?consent_debug=0.
 *
 * Reads window.Shopify.customerPrivacy directly -- NOT our own
 * PrivacyOptOut/localStorage logic -- so every value here is Shopify's own
 * ground-truth determination, not what our code assumes it should be.
 */
(function () {
  'use strict';

  var params = new URLSearchParams(location.search);
  if (params.get('consent_debug') === '1') {
    sessionStorage.setItem('consent_debug', '1');
  } else if (params.get('consent_debug') === '0') {
    sessionStorage.removeItem('consent_debug');
  }
  if (sessionStorage.getItem('consent_debug') !== '1') return;

  function deepFind(selector, root) {
    var el = root.querySelector(selector);
    if (el) return el;
    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].shadowRoot) {
        var found = deepFind(selector, nodes[i].shadowRoot);
        if (found) return found;
      }
    }
    return null;
  }

  function safeCall(cp, method) {
    if (!cp || typeof cp[method] !== 'function') return 'n/a';
    try {
      return cp[method]();
    } catch (e) {
      return 'error: ' + e.message;
    }
  }

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function snapshot() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    var bannerEl = deepFind('#shopify-pc__banner, .shopify-pc__banner', document);
    var declineEl = deepFind('.shopify-pc__banner__btn-decline', document);
    var d = {
      time: new Date().toISOString(),
      href: location.href,
      nativeApiReady: !!cp,
      region: safeCall(cp, 'getRegion'),
      saleOfDataRegion: safeCall(cp, 'saleOfDataRegion'),
      analyticsProcessingAllowed: safeCall(cp, 'analyticsProcessingAllowed'),
      marketingAllowed: safeCall(cp, 'marketingAllowed'),
      saleOfDataAllowed: safeCall(cp, 'saleOfDataAllowed'),
      currentVisitorConsent: safeCall(cp, 'currentVisitorConsent'),
      nativeBannerInDom: !!bannerEl,
      nativeBannerVisible: isVisible(bannerEl),
      declineBtnInDom: !!declineEl,
      declineBtnVisible: isVisible(declineEl),
      legacyThemeBannerInDom: !!document.querySelector('.cookie_consent'),
      noticeBannerVisible: isVisible(document.getElementById('notice-consent-banner')),
      consentRequiredRegionClassOnHtml: document.documentElement.classList.contains('consent-required-region')
    };

    // Derived expectation check: what SHOULD happen for this region, and does
    // the Decline button's actual gating (the .consent-required-region class)
    // match? analyticsProcessingAllowed() is the region signal pre-decision.
    if (d.analyticsProcessingAllowed === false) {
      d.regionModel = 'opt-out-by-default (consent-required) -> Decline EXPECTED';
      d.declineGatingMatchesModel = (d.consentRequiredRegionClassOnHtml === true);
    } else if (d.analyticsProcessingAllowed === true) {
      d.regionModel = 'opt-in-by-default (allowed) -> NO Decline expected';
      d.declineGatingMatchesModel = (d.consentRequiredRegionClassOnHtml === false);
    } else {
      d.regionModel = 'undetermined (API not ready yet?)';
      d.declineGatingMatchesModel = 'n/a';
    }
    return d;
  }

  var panel = document.createElement('div');
  panel.id = 'consent-debug-panel';
  panel.style.cssText = 'position:fixed;top:0;right:0;bottom:auto;z-index:2147483647;' +
    'background:#000;color:#0f0;font:11px/1.5 monospace;padding:8px 10px;' +
    'max-width:420px;white-space:pre-wrap;pointer-events:none;opacity:0.94;' +
    'border-bottom-left-radius:6px;';

  // Append to <body> when it exists (more reliable stacking than <html>), but
  // fall back to <html> if this deferred script somehow runs pre-body. Retry
  // the body attach shortly after in case it wasn't there on first pass.
  function attachPanel() {
    if (panel.isConnected) return;
    (document.body || document.documentElement).appendChild(panel);
  }
  attachPanel();

  var lastSerialized = null;
  var pollCount = 0;
  var observer = null;

  // Updating panel.textContent is itself a DOM mutation inside the subtree
  // the observer below watches, so it must be disconnected while we write to
  // the panel -- otherwise the observer re-fires on its own update and loops
  // forever (starving the page, including the actual banner render).
  function render(reason) {
    attachPanel();
    var d = snapshot();

    // The PANEL is repainted on EVERY call (with a live heartbeat line) so it
    // never looks frozen while we wait for Shopify's API to resolve -- that
    // "frozen/nothing-happening" look was the reported symptom. Only the
    // CONSOLE log is deduped, so DevTools doesn't get spammed with identical
    // snapshots while polling.
    if (observer) observer.disconnect();
    panel.textContent =
      'CONSENT DEBUG  (?consent_debug=0 to hide)\n' +
      'updated: ' + d.time.split('T')[1] + '  (' + reason + ', poll ' + pollCount + ')\n' +
      'apiReady: ' + d.nativeApiReady + '\n' +
      'region: ' + d.region + '\n' +
      'MODEL: ' + d.regionModel + '\n' +
      'decline gating matches model: ' + d.declineGatingMatchesModel + '\n' +
      'analyticsAllowed: ' + d.analyticsProcessingAllowed + '\n' +
      'marketingAllowed: ' + d.marketingAllowed + '\n' +
      'saleOfDataAllowed: ' + d.saleOfDataAllowed + '\n' +
      'saleOfDataRegion: ' + d.saleOfDataRegion + '\n' +
      'currentVisitorConsent: ' + JSON.stringify(d.currentVisitorConsent) + '\n' +
      'nativeBannerInDom: ' + d.nativeBannerInDom + '  |  VISIBLE: ' + d.nativeBannerVisible + '\n' +
      'declineBtnInDom: ' + d.declineBtnInDom + '  |  VISIBLE: ' + d.declineBtnVisible + '\n' +
      'noticeBannerVisible (opt-in-region banner): ' + d.noticeBannerVisible + '\n' +
      '.consent-required-region on <html>: ' + d.consentRequiredRegionClassOnHtml + '\n' +
      'legacyThemeBannerInDom: ' + d.legacyThemeBannerInDom;
    if (observer) observer.observe(document.documentElement, { childList: true, subtree: true });

    // Compare everything except `time` (always fresh, so it would defeat
    // the dedup below on every single call) and `href` (irrelevant here --
    // a real navigation re-runs this whole script from scratch anyway).
    var comparable = Object.assign({}, d);
    delete comparable.time;
    delete comparable.href;
    var serialized = JSON.stringify(comparable);
    // Console: skip identical, unchanged snapshots so polling/mutation stays
    // quiet in DevTools when nothing has actually changed.
    if (serialized === lastSerialized && reason !== 'initial') return;
    lastSerialized = serialized;
    console.log('[CONSENT DEBUG]' + (reason ? ' (' + reason + ')' : ''), d);
  }

  render('initial');

  document.addEventListener('visitorConsentCollected', function () {
    render('visitorConsentCollected');
  });

  var timer = setInterval(function () {
    pollCount += 1;
    render('poll');
    if (pollCount >= 30) clearInterval(timer); // ~15s, then rely on the observer below
  }, 500);

  if (typeof MutationObserver === 'function') {
    observer = new MutationObserver(function () { render('dom mutation'); });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
